export const toNumber = (value) => {
  if (typeof value === 'number') return value;
  if (value == null) return 0;
  const normalized = String(value).replace(/[^\d.-]/g, '');
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizeEnglishDigits = (value = '') => {
  const input = String(value ?? '');
  const fa = '۰۱۲۳۴۵۶۷۸۹';
  const ar = '٠١٢٣٤٥٦٧٨٩';
  return input.replace(/[۰-۹]/g, (d) => String(fa.indexOf(d))).replace(/[٠-٩]/g, (d) => String(ar.indexOf(d)));
};

export const getDateValue = (pickerValue) => {
  if (!pickerValue) return '';
  const raw = pickerValue?.format?.('YYYY/MM/DD') || String(pickerValue);
  return normalizeEnglishDigits(raw.replace(/-/g, '/'));
};

/** مقدار تقویم بازه‌ای: هر دو خالی => [] ، یکی/دو رشته تاریخ */
export const getDateRangePickerValue = (startDate, endDate) => {
  if (!startDate && !endDate) return [];
  if (startDate && endDate) return [startDate, endDate];
  if (startDate) return [startDate];
  return [];
};

/** خروجی onChange تقویم بازه‌ای → startDate / endDate (ارقام انگلیسی) */
export const parseDateRangeChange = (dates) => {
  if (!dates || !dates.length) return { startDate: '', endDate: '' };
  const start = dates[0] ? getDateValue(dates[0]) : '';
  const end = dates[1] ? getDateValue(dates[1]) : '';
  return { startDate: start, endDate: end };
};

/** ماه دو رقمی برای کوئری/API */
export const padMonth = (month) => String(Number(month) || 1).padStart(2, '0');

export const extractRows = (response) => {
  const payload = response?.data ?? response;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const extractPagination = (response) => {
  const payload = response?.data ?? response;
  const pg = payload?.pagination || payload;
  return {
    current: pg?.current_page || 1,
    pageSize: Number(pg?.per_page) || 15,
    total: Number(pg?.total) || 0,
  };
};
